// AuthContext — thin provider shell (real auth handled by Lumi SDK via useAuth hook)
import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

interface AuthCtx { _placeholder: true }
const Ctx = createContext<AuthCtx>({ _placeholder: true })

export function AuthProvider({ children }: { children: ReactNode }) {
  return <Ctx.Provider value={{ _placeholder: true }}>{children}</Ctx.Provider>
}

export function useAuthContext() {
  return useContext(Ctx)
}
